import type { EnrichmentOverrides } from 'types/context';

/** Atlas surface — node-level visual signals. */
export const ATLAS_ENRICHMENT: EnrichmentOverrides = {
  includeStatus: true,
  includeEdgeCount: true,
  includeApproachDeployments: true,
};

/** Armillary view — orbital arcs need stage info. */
export const ARMILLARY_ENRICHMENT: EnrichmentOverrides = {
  includeStatus: true,
  includeFlow: true,
};

/** Walk-node renderer in the editor preview / public walk surface. */
export const WALK_NODE_ENRICHMENT: EnrichmentOverrides = {
  includeStatus: true,
  includeApproachDeployments: true,
  includeEdgeCount: true,
};

/** ContextSummary cards — compact mode, status only. */
export const SUMMARY_ENRICHMENT: EnrichmentOverrides = {
  includeStatus: true,
};

/** TreeMap — node tiles show status + points for ranking. */
export const TREEMAP_ENRICHMENT: EnrichmentOverrides = {
  includeStatus: true,
  includePoints: true,
};

/** Picker / minimal — bare names, no enrichment. */
export const MINIMAL_ENRICHMENT: EnrichmentOverrides = {};
